import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import Loading from '../Loading'

export default function StakingClaimDialog({ program, myDeposit, requestClaim, isLoading, onClose }) {
  return (
    <Transition.Root show={true} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 w-screen overflow-y-auto bg-jacarta-200 bg-opacity-60">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="w-[350px] h-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900">
                  {program.rewardToken} Harvest
                </Dialog.Title>
                <div className="relative mt-6">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-jacarta-100" />
                  </div>
                </div>
                <div className="mt-14 h-[100px] text-sm font-semibold">
                  <div>Harvesting:</div>
                  <p className="text-gray-500 text-[23px] mt-2">
                    <span className="text-jacarta-800 font-bold">
                      {myDeposit.rewardAmount} {program.rewardToken}
                    </span>
                  </p>
                </div>
                <div className="mb-4">
                  <button
                    type="button"
                    disabled={isLoading}
                    className="flex justify-center items-center w-full h-12 hover:bg-jacarta-600 text-[16px] rounded-full bg-[#131740] dark:bg-white text-white dark:text-[#131740]"
                    onClick={() => {
                      requestClaim(program.externalId)
                    }}
                  >
                    {isLoading ? (
                      <div>
                        <Loading />
                      </div>
                    ) : (
                      'Confirm'
                    )}
                  </button>

                  <button
                    type="button"
                    className="w-full mt-3 text-sm text-jacarta-600 dark:text-jacarta-200"
                    onClick={onClose}
                  >
                    Close
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
